import React ,{Component} from 'react'; 
import { Navigate  } from 'react-router-dom';
import axios from 'axios'; 
import Table from '@mui/material/Table';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow'; 
import { styled } from '@mui/system'; 
import Paper from '@mui/material/Paper';  
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  
import TablePagination from '@mui/material/TablePagination'; 
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import AddBoxRoundedIcon from '@mui/icons-material/AddBoxRounded';
import FormControl from '@mui/material/FormControl';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Typography from '@mui/material/Typography';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
 import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormLabel from '@mui/material/FormLabel';
export  default class  AddCustomerbox extends Component {
   constructor(props) {
      super(props)
      this.state = {
		   open:false,name:'',cu_id:0,iscreditlimit:false,cu_creditlimit:'0.00',iscreditterms:false,creditlimitdisable:true,cu_noofdays:'0',
      errormessage:'',erropen:false,btndisabled:false,tab:"0", value:0,countrydata:[],ledgerdata:[],countrylabel:'Select Country',masterlabel:'Select',statelabel:'select state',taxlabel:'Tax Rate',bname:'',name:'', refno:'',emailid:'',mobileno:'', phone:'', coid:'', billaddress1:'',billaddress2:'',billcity:'', billstate:'',billpin:'',cu_shipco_id:'',shipcountrylabel:'Select',
	 tax:'',shipaddress1:'',shipaddress2:'', shipcity:'', shipstate:'',shippin:'',credit:'',trems:'',cmonth:'', days:'', policy:'',cu_bankaccountname:'',cu_bankroutingno:'',cu_bankaccountno:'',price:'',
	  cu_note:'', ledger:'',submitbtn:"Save",masterdata:[],statedata:[],taxdata:[],isChecked: false, txtvalue:0,allchecked:false,isallchecked:false, Checkboxvalue:0,shipchecked:true,
	  }
  }
Customergetdata() {
  if (this.props.id !== 0) {
    axios
      .get(localStorage.getItem("ISIurl") + 'ajaxcustomer.php?action=getall&cu_id=' + this.props.id)
      .then(resp => {
        if (resp.data.length > 0) {
          const row = resp.data[0];
          const iscreditterms =
            row.cu_setcreditterms == 1 ||
            row.cu_noofdays > 0 ||
            row.cu_credittermsnextmonth == 1 ||
            (row.cu_creditermsimmediatepolicy && row.cu_creditermsimmediatepolicy !== "");
          let credittermstype = "";
          if (row.cu_noofdays > 0) {
            credittermstype = "1"; 
          } else if (row.cu_credittermsnextmonth == 1) {
            credittermstype = "2"; 
          } else if (row.cu_creditermsimmediatepolicy && row.cu_creditermsimmediatepolicy !== "") {
            credittermstype = "3"; 
          }
          const iscreditlimit = row.cu_creditlimit != 0;
          const creditlimitdisable = !iscreditlimit;
          this.setState({
            cu_id: row.cu_id,
            bname: row.cu_businessname,
            name: row.cu_contactname,
            refno: row.cu_referenceno,
            emailid: row.cu_emailid,
            mobileno: row.cu_mobileno,
            phone: row.cu_phoneno,
            coid: row.cu_co_id,
            cu_shipco_id: row.cu_shipco_id,
            billaddress1: row.cu_billingaddress1,
            billaddress2: row.cu_billingaddress2,
            billcity: row.cu_billingcity,
            billstate: row.cu_billingstate,
            billpin: row.cu_billingpincode,
            tax: row.cu_tax_id,
            shipaddress1: row.cu_shippingaddress1,
            shipaddress2: row.cu_shippingaddress2,
            shipcity: row.cu_shippingcity,
            shipstate: row.cu_shippingstate,
            shippin: row.cu_shippingpincode,
            cu_creditlimit: row.cu_creditlimit,
            iscreditterms,
            credittermstype,
            cu_noofdays: row.cu_noofdays || "",
            cu_creditermsimmediatepolicy: row.cu_creditermsimmediatepolicy || "",
            iscreditlimit,
            creditlimitdisable,
            cu_bankaccountname: row.cu_bankaccountname,
            cu_bankroutingno: row.cu_bankroutingno,
            cu_bankaccountno: row.cu_bankaccountno,
            price: row.cu_pricedefault,
            cu_note: row.cu_note,
            ledger: row.cu_ledger_id,
          });
        }
      });
  } else {
    this.setState({
      cu_id: 0,
      bname: '',
      name: '',
      refno: '',
      emailid: '',
      mobileno: '',
      phone: '',
      coid: '',
      billaddress1: '',
      billaddress2: '',
      billcity: '',
      billstate: '',
      billpin: '',
      tax: '',
      shipaddress1: '',
      shipaddress2: '',
      shipcity: '',
      shipstate: '',
      shippin: '',
      cu_creditlimit: '',
      iscreditterms: false,
      credittermstype: "",
      cu_noofdays: '',
      cu_creditermsimmediatepolicy: '',
      iscreditlimit: false,
      creditlimitdisable: true,
      cu_bankaccountname: '',
      cu_bankroutingno: '',
      cu_bankaccountno: '',
      price: '',
      cu_note: '',
      ledger: '',
      tab: "0",
      newValue: '',
      value: 0,
      Checkboxvalue: 0,
    });
  }
}
	handlecreditterms = (event) => 
{
	this.setState({iscreditterms: !this.state.iscreditterms});
};
onclickcustomerclose = (e) => {
	 this.setState({open:false});
} 
	handlecreditlimitChange = (event) => 
{
	this.setState({iscreditlimit: !this.state.iscreditlimit,creditlimitdisable:!this.state.creditlimitdisable},()=>{});
}; 
   handleshipChange = (event) => 
{
	this.setState({shipchecked: !this.state.shipchecked},()=>{
		if(this.state.shipchecked===false)
		{
		 this.setState({
	 shipaddress1:"",
	 shipaddress2:"",
	 shipcity:"",
	 shipstate:"",
	  shippin:"",
	 })
		}else{
		 this.setState({cu_shipco_id: this.state.coid,
	 shipaddress1:this.state.billaddress1,
	 shipaddress2:this.state.billaddress2,
	 shipcity:this.state.billcity,
	 shipstate:this.state.billstate,
	  shippin:this.state.billpin,
	 })	
		}
	});
};
handleradiocredit = (event) => 
{
	this.setState({credittermstype: event.target.value});
};
handleClickOpen = (e) => {
   if(localStorage.getItem("ISIuserid")==null)
		  {
		   this.setState({
            redirect: true,
			pagename:'/Login'
          })
		  }
else
{	
		if(localStorage.getItem("ISIrole")==="1" || localStorage.getItem("ISIrole")==="2")
		  {			
		  }
		  else{	    
		this.PageAccessCheckApi();
         }
}
  this.setState({redirect:false,pagename:'',open:!this.state.open,  name:'',emailid:'',phone:'',bname:'',
	 refno:'',mobileno:'',coid:'', billaddress1:'',billaddress2:'',billcity:'',billstate:'',billpin:'',tax:'',
	 shipaddress1:'',shipaddress2:'',billaddress2:'',shipcity:'',shipstate:'',shippin:'',credit:'',trems:'',
	cmonth:'',billaddress2:'',days:'',cu_creditermsimmediatepolicy:'',cu_bankaccountname:'',cu_bankroutingno:'',cu_bankaccountno:'',price:'',cu_note:'',
     errormessage:'',erropen:false,tab:"0",newValue:'',ledger:'',Checkboxvalue:0,
	  });
this.countrybind();
};
PageAccessCheckApi() {
  axios.get(localStorage.getItem("ISIurl")+'ajaxpagemaster.php?action=getbyuser&us_id='+localStorage.getItem('ISIuserid')+'&up_pm_id=4')
  .then(resp => {
	  let strreturn=resp.data;
      if (strreturn!==0) {
      } else {
        this.setState({redirect: true,pagename: "/Accesspagemessage"});
      }
  });
}
  handleChange = (event, newValue) => {
    this.setState({ tab: newValue });
	 this.setState({                   
     Checkbox: event.target.value      
   })
  }
  countrybind(){
    axios.get(localStorage.getItem("ISIurl")+'ajaxcountry.php?action=getall')
      .then((resp) => {     
	  let CountryApi = resp.data.map(row => {
          return {value:row.co_id, display:row.co_name}
        });
		  this.setState({
			    countrydata: [{value:'', display:'Select Country'}].concat(CountryApi)
        });
		this.pricebind();
      }).then(data => {
      })
}
statebind(){
    axios.get(localStorage.getItem("ISIurl")+'ajaxlocation.php?action=getall')
      .then((resp) => {     
	  let StateApi = resp.data.map(row => {
          return {value:row.lo_state, display:row.lo_state}
        });
		 this.setState({
          statedata: [{value:'', display:'Select State'}].concat(StateApi)
        });
		this.taxbind();
      }).then(data => {
      })
}
  pricebind(){
    axios.get(localStorage.getItem("ISIurl")+'ajaxgroupmaster.php?action=getall&gm_type=1&gm_cmp_id='+localStorage.getItem("ISIcmpid"))
      .then((resp) => {     
	  let PriceApi = resp.data.map(row => {
          return {value:row.gm_id, display:row.gm_name}
        });
		 this.setState({
          masterdata: [{value:'', display:'Select'}].concat(PriceApi)
        });
		this.statebind();
      }).then(data => {
      })
}
  taxbind(){
    axios.get(localStorage.getItem("ISIurl")+'ajaxtax.php?action=getall&tx_cmp_id='+localStorage.getItem("ISIcmpid")+'&tx_mainid=0')
	 .then((resp) => {     
	  let TaxApi = resp.data.map(row => {
          return {value:row.tx_id, display:row.tx_name}
        });
		 this.setState({
          taxdata: [{value:'', display:'Select tax'}].concat(TaxApi)
        });
		this.ledgerbind();
      }).then(data => {
      })
}
  ledgerbind(){
 axios.get(localStorage.getItem("ISIurl")+'ajaxledger.php?action=getall&le_cmp_id='+localStorage.getItem("ISIcmpid")+'&le_issales=1&sorting=le_id')
	 .then((resp) => {     
	  let LedgerApi = resp.data.map(row => {
          return {value:row.le_id, display:row.le_code+" - "+row.le_ledgername}
        });
		 this.setState({
          ledgerdata: [{value:'', display:'Select'}].concat(LedgerApi)
        });
		this.Customergetdata();
      }).then(data => {
      })
}
 formatPhoneNumber = (value) => {
    // Remove all non-digit characters
    const cleaned = value.replace(/\D/g, "");
    // Format based on length
    if (cleaned.length <= 3) {
      return `(${cleaned}`;
    } else if (cleaned.length <= 6) {
      return `(${cleaned.slice(0, 3)})-${cleaned.slice(3)}`;
    } else {
      return `(${cleaned.slice(0, 3)})-${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`;
    }
  };
 myChangeHandler = (event) => {
  const re = /^[0-9\.]+$/;
  let nam = event.target.name;
  let val = event.target.value;
if(nam==="phone" )
{
	const inputValue = event.target.value;
    const formatted = this.formatPhoneNumber(inputValue);
	this.setState({[nam]: formatted}); 
}
else if( nam==="mobileno" || nam==="cu_creditlimit")
{
if (event.target.value === '' || re.test(event.target.value)) {
	  this.setState({[nam]: val}); 
  }	
}else if(nam==="coid" || nam==="billaddress1" || nam==="billaddress2" || nam==="billcity" || nam==="billstate" || nam==="billpin")
{
 this.setState({[nam]: val},()=>{
	 if(this.state.shipchecked===true)
	 {
	 this.setState({cu_shipco_id: this.state.coid,
	 shipaddress1:this.state.billaddress1,
	 shipaddress2:this.state.billaddress2,
	 shipcity:this.state.billcity,
	 shipstate:this.state.billstate,
	  shippin:this.state.billpin,
	 })
	 }
 });
}	else{
  this.setState({[nam]: val},()=>{});
  }
}
handleClose = (e) => {
	let bname = this.state.bname;
    let name = this.state.name;
    let refno = this.state.refno;
	let emailid = this.state.emailid;
	let mobileno= this .state.mobileno;
    let phone = this.state.phone;
    let coid = this.state.coid;
    let billaddress1=this.state.billaddress1;
	let billaddress2 = this.state.billaddress2;
	let billcity = this.state.billcity;
	let billstate= this.state.billstate;
	let billpin= this.state.billpin;
	let tax= this.state.tax;
	let shipaddress1= this.state.shipaddress1;
	let shipaddress2= this.state.shipaddress2;
	let  shipcity= this.state.shipcity;
	let  shipstate= this.state.shipstate;
	let  shippin= this.state.shippin;
	let  cu_creditlimit= this.state.cu_creditlimit;
	if (cu_creditlimit === "" || cu_creditlimit === null || cu_creditlimit === undefined) {
    cu_creditlimit = 0;
}
	let  trems= this.state.trems;
	let  cmonth= this.state.cmonth;
	let  days= this.state.days;
	let  cu_creditermsimmediatepolicy= this.state.cu_creditermsimmediatepolicy;
	let  cu_bankaccountname= this.state.cu_bankaccountname;
	let  cu_bankroutingno= this.state.cu_bankroutingno;
	let cu_bankaccountno= this.state.cu_bankaccountno;
	let  price= this.state.price;
	let  cu_note= this.state.cu_note,cu_shipco_id=this.state.cu_shipco_id,cu_noofdays=this.state.cu_noofdays;
let ledger=this.state.ledger;
if (ledger === "" || ledger === null || ledger === undefined) {
    ledger = 0;
}
let credittermstype=this.state.credittermstype,strisbilling="1";
	let iscreditterms=this.state.iscreditterms,striscreditterms="0",strcredittermstype="0";
	if(iscreditterms===true)
	{
		striscreditterms="1";
	}
if(credittermstype==="2")
	{
		strcredittermstype="1";
	}
	if(credittermstype!=="1")
	{
		cu_noofdays="0"
	}
	if(this.state.shipchecked===false)
	{
		strisbilling="0";
	}
 const remail= /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
 if(bname==="")
{
	this.setState({errormessage:"Please Enter Business Name",erropen:true});
		 return false;
}
if(name==="")
{
	this.setState({errormessage:"Please Enter Contact Name",erropen:true});
		 return false;
}
if(refno==="")
{
	this.setState({errormessage:"Please Enter Reference  No",erropen:true});
		 return false;
}
if(emailid==="")
{
	this.setState({errormessage:"Please Enter Email.",erropen:true});
	return false;
}
else{
	 if (!remail.test(emailid)) {
	 this.setState({errormessage:"Please Enter Valid Email Id",erropen:true});		
	return false; 
  }
}
if (mobileno=="")
{
	this.setState({errormessage:"Please Enter Mobile Number",erropen:true});
		 return false;
}
if (phone=="")
{
	this.setState({errormessage:"Please Enter Phone Number",erropen:true});
		 return false;
}
 if(coid==="")
{
	this.setState({errormessage:"Please Select Country",erropen:true});
		 return false;
}
if(billaddress1==="")
{
	this.setState({errormessage:"Please Enter Address",erropen:true});
		 return false;
}
if(billaddress2==="")
{
	this.setState({errormessage:"Please Enter Address",erropen:true});
		 return false;
}
 if(billcity==="")
{
	this.setState({errormessage:"Please Enter City",erropen:true});
		 return false;
}
if(billstate==="" || billstate==="0")
{
this.setState({errormessage:"Please Select State",erropen:true});
						 window.scrollTo({        top: 0     })
						 return false; 
}
if(billpin==="")
{
	this.setState({errormessage:"Please Enter Zip Code",erropen:true});
		 return false;
}
if(tax==="" || tax==="0")
{
	this.setState({errormessage:"Please Select Tax Rate",erropen:true});
		 return false;
}
if(price==="" || price==="0")
{
	this.setState({errormessage:"Please Select Price Default",erropen:true});
		 return false;
}
 this.setState({btndisabled:true,submitbtn:"Processing..."})
   var formData = new FormData();
   if(this.state.cu_id===0)
	  {
		  formData.append('cu_id',0) 
	  }
	  else
	  {
	   formData.append('cu_id',this.state.cu_id)
          }
        formData.append('action','insertorupdate') 
		formData.append('cu_businessname',bname)
		formData.append('cu_contactname',name)
		formData.append('cu_referenceno',refno)
		formData.append('cu_emailid',emailid)
		formData.append('cu_mobileno',mobileno)
		formData.append('cu_phoneno',phone)
		formData.append('cu_co_id',coid) 
		formData.append('cu_billingaddress1',billaddress1)
		formData.append('cu_billingaddress2',billaddress2)
		formData.append('cu_billingcity',billcity)
		formData.append('cu_billingstate',billstate)
		formData.append('cu_billingpincode',billpin)
		formData.append('cu_tax_id',tax)
		formData.append('cu_shippingaddress1',shipaddress1) 
		formData.append('cu_shippingaddress2',shipaddress2)
		formData.append('cu_shippingcity',shipcity)
		formData.append('cu_shippingstate',shipstate)
		formData.append('cu_shippingpincode',shippin)
		formData.append('cu_creditlimit',cu_creditlimit)
		formData.append('cu_setcreditterms',striscreditterms)
		formData.append('cu_credittermsnextmonth',strcredittermstype) 
		formData.append('cu_noofdays',this.state.cu_noofdays)
		formData.append('cu_creditermsimmediatepolicy',this.state.cu_creditermsimmediatepolicy)
		formData.append('cu_bankaccountname',cu_bankaccountname)
		formData.append('cu_bankroutingno',cu_bankroutingno)
		formData.append('cu_bankaccountno',cu_bankaccountno)
		formData.append('cu_pricedefault',price)
		formData.append('cu_note', cu_note)
		formData.append('cu_ledger_id',ledger)
		formData.append('userid',localStorage.getItem("ISIuserid"))
		formData.append('cu_cmp_id',localStorage.getItem("ISIcmpid"))
		  formData.append('cu_shipco_id',cu_shipco_id)
		   formData.append('cu_isbilling',strisbilling)
		axios.post(localStorage.getItem("ISIurl")+"ajaxcustomer.php", formData, {
        }).then(res => {
	if(res.data === -1)
{ 
		this.setState({errormessage:"Name Already Exist.",erropen:true,open:true
		});
		window.scrollTo({
          top: 0
      })
		 return false;
	}else{
		this.props.parentcustomerinsert(res.data);
	}
        });
	this.setState({ open:false,btndisabled:false,
	 submitbtn:"Save", });
};
	 handleErrorclose=(event)=>{
	this.setState({erropen: false});  
  } 
	 setIsChecked = (isChecked) => {
    this.setState({isChecked });
	this.setState({Checkbox:0});
  }
render (){
	  if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />;
    }
 const { ...props } = this.props;
return(
<React.Fragment>
    <Dialog open={this.state.open} onClose={this.onclickcustomerclose} maxWidth="md"   className="popup" aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title"> Create a new customer</DialogTitle>
      <DialogContent >
<div className="formlist">
	<p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity="error"
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
	<div className="customerform">
<ul>
	<li>	
	<p className="popformtext">  Business Name <span className="validation">*</span></p>
	<p className="popforminputs"><TextField name="bname" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.bname}
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "1",maxLength:150}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>
		  <div className="clear"></div>
</li>					  
	<li>	
	<p className="popformtext"> Contact Name <span className="validation">*</span></p>
	<p className="popforminputs"><TextField name="name" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.name}
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "2",maxLength:150}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>
		  <div className="clear"></div>
</li>
	<li>	
	<p className="popformtext">Reference<span className="validation">*</span></p>
	<p className="popforminputs"><TextField name="refno" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.refno}
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "3",maxLength:12}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>
		  <div className="clear"></div>
</li>
<li>
	<p className="popformtext"> Email<span className="validation">*</span></p>
	<p className="popforminputs"><TextField name="emailid" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.emailid}
	  ref={this.usernameInput}
	 inputProps={{tabIndex: "4",maxLength:150}}
			 className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>
		  <div className="clear"></div>
</li>	
<li>	
	<p className="popformtext"> Mobile<span className="validation">*</span></p>
	<p className="popforminputs"><TextField name="mobileno" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.mobileno}
			  inputProps={{tabIndex: "5",maxLength:15}}
			  ref={this.usernameInput}
			 className="txtbox"
	   InputLabelProps={{ shrink: true }}
		  /></p>
		  <div className="clear"></div>
</li>					  
		<li>
	<p className="popformtext">Telephone<span className="validation">*</span></p>
	<p className="popforminputs"><TextField name="phone" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.phone}
			  inputProps={{tabIndex: "6",maxLength:15}}
			  ref={this.usernameInput}
			 className="txtbox"
	   InputLabelProps={{ shrink: true }}
		  /></p>
		   <div className="clear"></div>
</li>
		  </ul>	
			</div>		
<Box sx={{ width: '100%', typography: 'body1' }}>
  <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
    <Tabs
      initialSelectedIndex={0}
      value={this.state.tab || "0"}
      onChange={this.handleChange}
      aria-label="lab API tabs example"
    >
      <Tab label="Account Details" value="0" />
      <Tab label="Delivery Address" value="1" />
      <Tab label="Payment Details" value="2" />
      <Tab label="Defaults" value="3" />
      <Tab label="Notes" value="4" />
    </Tabs>
  </Box>
    </Box>
		 {this.state.tab==="0" && (
<div className="Accountform">
<div className="addresleft">
<ul>
 <li>
		 <p className="popformtext"> &nbsp;</p>
		  <p  className="popforminputs"><FormControl  className="stadrp">
        <Select
         native  fullWidth		 
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.countrylabel, value: this.state.coid}}
          onChange={this.myChangeHandler}
          id="coid"
		   value={this.state.coid} className="txtbox"
		  name="coid"
		inputProps={{tabIndex: "7"}}
        >
		{this.state.countrydata.map(con => (
            <option  
              value={con.value}
            >
              {con.display}
            </option  >
          ))}
        </Select></FormControl>
		</p>
		<div className="clear"></div>
		  </li>
	<li>	
	<p className="popformtext">  Address 1<span className="validation">*</span></p>
	<p className="popforminputs"><TextField name="billaddress1" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.billaddress1}
		 inputProps={{tabIndex: "8"}}	 
			  ref={this.usernameInput}
			   className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>
		  <div className="clear"></div>
</li>
	<li>	
	<p className="popformtext">Address 2 <span className="validation">*</span></p>
	<p className="popforminputs"><TextField name="billaddress2" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.billaddress2}
			 inputProps={{tabIndex: "9"}}	 
			  className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>
		  <div className="clear"></div>
</li>
<li>	
	<p className="popformtext">Town/City <span className="validation">*</span></p>
	<p className="popforminputs"><TextField name="billcity" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.billcity}
			  inputProps={{tabIndex: "10",maxLength:150}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>
		  <div className="clear"></div>
</li>
<li>
		 <p className="popformtext"> State <span className="validation">*</span></p>
		  <p><FormControl   className="popforminputs">
        <Select
         native  fullWidth		 
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.statelabel, value: this.state.billstate}}
          onChange={this.myChangeHandler}
          id="billstate"
		   value={this.state.billstate}
inputProps={{tabIndex: "11",maxLength:150}}		  
		  name="billstate"
		   className="txtbox"
		inputProps={{tabIndex: "8"}}
        >
		{this.state.statedata.map(states => (
            <option  
              value={states.value}
            >
              {states.display}
            </option  >
          ))}
        </Select></FormControl>
		 <div className="clear"></div>
		</p>
		  </li>
<li>	
	<p className="popformtext"> Zip Code <span className="validation">*</span></p>
	<p className="popforminputs"><TextField name="billpin" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.billpin}
			 inputProps={{tabIndex: "12",maxLength:15}}
			 className="txtbox"
	   InputLabelProps={{ shrink: true }}
		  /></p>
		  <div className="clear"></div>
</li>					  
	</ul></div>
	<div className="otherdetailsright">
	<ul>
	<li>
		 <p className="popformtext"> Account Default</p>
		  <p ><FormControl  className="popforminputs">
        <Select
         native  fullWidth		 
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.ledgerlabel, value: this.state.ledger}}
          onChange={this.myChangeHandler}
          id="ledger"
		   value={this.state.ledger} className="txtbox"
		  name="ledger"
		inputProps={{tabIndex: "13"}}
        >
		{this.state.ledgerdata.map(ledger => (
            <option  
              value={ledger.value}
            >
              {ledger.display}
            </option  >
          ))}
        </Select></FormControl>
		 <div className="clear"></div>
		</p>
		  </li>
		<li>
		 <p className="popformtext"> Tax Rate <span className="validation">*</span></p>
		  <p><FormControl className="popforminputs">
        <Select
         native  fullWidth		 
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.taxlabel, value: this.state.tax}}
          onChange={this.myChangeHandler}
          id="tax"
		   className="txtbox"
		   value={this.state.tax} 
		  name="tax"
		inputProps={{tabIndex: "14"}}
        >
		{this.state.taxdata.map(tax => (
            <option  
              value={tax.value}
            >
              {tax.display}
            </option  >
          ))}
        </Select></FormControl>
		 <div className="clear"></div>
		</p>
		  </li>
		  </ul>	
			</div>		
	  <div className="clear"></div>
</div>	
		 )}		 
 {this.state.tab==="1" && (
 <div className="Accountform">
<FormControlLabel
        label="Same as Invoice address"
        control={ <Checkbox  checked={this.state.shipchecked}  onChange={this.handleshipChange}  inputProps={{ 'aria-label': 'controlled' }} />}
      />
	  {this.state.shipchecked===true && (
	   <div className="formlayer"></div>
	  )}
<ul >
  <li>
		 <p className="popformtext"> </p>
		  <p><FormControl className="popforminputs">
        <Select
         native  fullWidth		 
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.shipcountrylabel, value: this.state.cu_shipco_id}}
          onChange={this.myChangeHandler}
          id="coid"
		   value={this.state.cu_shipco_id} className="txtbox"
		  name="cu_shipco_id"
		inputProps={{tabIndex: "15"}}
        >
		{this.state.countrydata.map(con => (
            <option  
              value={con.value}
            >
              {con.display}
            </option  >
          ))}
        </Select></FormControl>
			<div className="clear"></div>
		</p>
		  </li>
<li>	
	<p className="popformtext">  Address 1 </p>
	<p className="popforminputs"><TextField name="shipaddress1" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.shipaddress1}
			  inputProps={{tabIndex: "16"}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>
		  <div className="clear"></div>
</li>					  
	<li>	
	<p className="popformtext">Address 2 </p>
	<p className="popforminputs"><TextField name="shipaddress2" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.shipaddress2}
	  inputProps={{tabIndex: "17"}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>
		  <div className="clear"></div>
</li>
	<li>	
	<p className="popformtext">Town/City</p>
	<p className="popforminputs"><TextField name="shipcity" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.shipcity}
			  inputProps={{tabIndex: "18",maxLength:150}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>
		  <div className="clear"></div>
</li>
<li>
		 <p  className="popformtext"> State</p>
		  <p><FormControl className="popforminputs">
        <Select
         native  fullWidth		 
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.statelabel, value: this.state.shipstate}}
          onChange={this.myChangeHandler}
          id="shipstate"
		   value={this.state.shipstate} className="txtbox"
		  name="shipstate"
		inputProps={{tabIndex: "19"}}
        >
		{this.state.statedata.map(states => (
            <option  
              value={states.value}
            >
              {states.display}
            </option  >
          ))}
        </Select></FormControl>
		 <div className="clear"></div>
		</p>
		  </li>
<li>	
	<p className="popformtext"> Zip Code </p>
	<p className="popforminputs"><TextField name="shippin" 
	   onChange={this.myChangeHandler}
	   fullWidth
	   value={this.state.shippin}
			 inputProps={{tabIndex: "20",maxLength:15}}
			 className="txtbox"
	   InputLabelProps={{ shrink: true }}
		  /></p>
		  <div className="clear"></div>
</li>					  
		  </ul>	
			</div>		
 )}	
 {this.state.tab==="2" && (
 <div className="Accountform">
    <div className="addresleft">
<ul>
 <h2>Payment Terms</h2>
	<li>	
	<p className="popformtext"> <FormControlLabel
        label="Set Credit Limits($)"
        control={ <Checkbox  checked={this.state.iscreditlimit}  onChange={this.handlecreditlimitChange}  inputProps={{ 'aria-label': 'controlled' }} />}
      /></p>
	<p className="popforminputs"><TextField name="cu_creditlimit" 
	   onChange={this.myChangeHandler}  
	   fullWidth
	 disabled={this.state.creditlimitdisable}
			  value={this.state.cu_creditlimit}
			  inputProps={{tabIndex: "21"}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>
		  <div className="clear"></div>
</li>	
	<li>	
	<p><FormControlLabel
        label="Set Credit Terms"
        control={ <Checkbox checked={this.state.iscreditterms}  onChange={this.handlecreditterms}  inputProps={{ 'aria-label': 'controlled' }} />}
      /></p>
</li>
 {this.state.iscreditterms===true && (<React.Fragment>
<li>
 <FormControl>
      <RadioGroup
        aria-labelledby="demo-radio-buttons-group-label"
        name="radio-buttons-group"
		  value={this.state.credittermstype}
    onChange={this.handleradiocredit}
      >
        <FormControlLabel value="1" control={<Radio />} label="days after invoice date" />
        <FormControlLabel value="2" control={<Radio />} label="End of next month (Net monthly)" />
        <FormControlLabel value="3" control={<Radio />} label="Immediately" />
      </RadioGroup>
    </FormControl>
	 {this.state.credittermstype==="1" && (<React.Fragment>
	<TextField name="cu_noofdays" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	    value={this.state.cu_noofdays}
	  inputProps={{tabIndex: "22"}}
			 className="txtbox"
	   InputLabelProps={{ shrink: true }}
                         />
	</React.Fragment> )}				 
	 {this.state.credittermstype==="3" && (				
<p><TextField name="cu_creditermsimmediatepolicy" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   multiline
	     rows={3}
	   value={this.state.cu_creditermsimmediatepolicy}
	     inputProps={{tabIndex: "23"}}
			 className="txtbox"
	   InputLabelProps={{ shrink: true }}
		  /></p>)}
</li>
	</React.Fragment>)}				  
</ul></div>
	<div className="otherdetailsright">
		  <h2>Bank Details</h2>
		  <ul>
		<li>
	<p className="popformtext">Account Name</p>
	<p className="popforminputs"><TextField name="cu_bankaccountname" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.cu_bankaccountname}
			 inputProps={{tabIndex: "24",maxLength:150}} 
			 className="txtbox"
	   InputLabelProps={{ shrink: true }}
		  /></p>
		   <div className="clear"></div>
</li>		
	<li>
	<p className="popformtext"> ABA/Routing<br/> Number</p>
	<p className="popforminputs"><TextField name="cu_bankroutingno" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.cu_bankroutingno}
			 inputProps={{tabIndex: "25",maxLength:15}}  
			 className="txtbox"
	   InputLabelProps={{ shrink: true }}
		  /></p>
		   <div className="clear"></div>
</li>		
	<li>
	<p className="popformtext">Account Number</p>
	<p className="popforminputs"><TextField name="cu_bankaccountno" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.cu_bankaccountno}
		 inputProps={{tabIndex: "26",maxLength:50}} 	 
			 className="txtbox"
	   InputLabelProps={{ shrink: true }}
		  /></p>
		   <div className="clear"></div>
</li>
</ul></div>	<div className="clear"></div>
</div>	
 )}
 {this.state.tab==="3" && (
<div className="Accountform">
    <div className="addresleft">
	<p className="popformtext">Price Default</p>
  <p><FormControl  className="popforminputs">
        <Select
         native  fullWidth		 
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.masterlabel, value: this.state.price}}
          onChange={this.myChangeHandler}
          id="price"
		   value={this.state.price}  className="txtbox"
		  name="price"
		inputProps={{tabIndex: "27"}}
        >
		{this.state.masterdata.map(cons => (
            <option  
              value={cons.value}
            >
              {cons.display}
            </option  >
          ))}
        </Select></FormControl>
		 <div className="clear"></div>
		</p>	 
</div>	  <div className="clear"></div>	
</div>	
 )}
 {this.state.tab==="4" && (
<div className="Accountform">
 <p>Notes</p>
<p><TextField name="cu_note" 
	   onChange={this.myChangeHandler} 
	 fullWidth
	      multiline
          rows={4}
	   value={this.state.cu_note}
		inputProps={{tabIndex: "28"}}	 
			 className="txtbox"
	   InputLabelProps={{ shrink: true }}
		  /></p>	
 </div>	
 )}
       <div className="actionbtns">
	   <div className="cancelbtn">
	   <Button variant="contained" className="frmthirdbtn" onClick={this.onclickcustomerclose}>
Cancel
</Button>
</div> 
<div className="savebtn">
<Button variant="contained" className="frmSecondarybtn" onClick={this.handleClose}>
    {this.state.submitbtn}
</Button>
    </div>        
<div className="clear"></div>
 </div>     
	</div>	
						    </DialogContent>
    </Dialog>
</React.Fragment>
) }
} 